(function () {
    'use strict';

    angular
        .module('styleVisualGuidelinesControllers')
        .controller('StyleIconsController', Controller);

    Controller.$inject = ['$scope', 'styleVisualGuidelinesService'];

    function Controller($scope, service) {

        service.getIcons()
            .then(function (icons) {
                $scope.icons = icons
            });
    }
})();